import React from "react";
import { HTMLAttributes } from "react";
import { useSelector } from "react-redux";
import reactCSS from "reactcss";
import classnames from "classnames";

import { StateShape } from "../../redux/store";
import { getContentColors } from "../../utils/colors";

type DialogContentProps = HTMLAttributes<HTMLDivElement>;

const stateSelector = (state: StateShape) => ({
    configurationData: state.configuration.data,
    applicationParams: state.application.params.params,
});

export const DialogContent = ({ className, ...props }: DialogContentProps) => {
    const { configurationData, applicationParams } = useSelector(stateSelector);

    const { textColor, backgroundColor } = getContentColors(configurationData, applicationParams);

    const styles = reactCSS({
        "default": {
            content: {
                backgroundColor,
                color: textColor,
            },
        },
    });

    return <div {...props} className={classnames("dialog-content", className)} style={styles.content} />;
};
